import { useSubsequentEffect } from '@carvana/merch-react-hooks';
import { useContext } from 'react';
import { useUserId } from '~/context/common/UserContext';
import UserVehicleContext, {
  useVdpPricing
} from '~/context/vdp/UserVehicleContext';
import toggleCoApplicant from '~/services/vdp/toggleCoApplicant';
import { generateErrorLogger } from '~/utilities/loggers';
import SptPriceDetailsContext from '../../SptPriceDetailsContext';

export default function useToggleCoApplicant() {
  const { isCoApplicantApplied, setCoApplicantApplied } = useContext(
    SptPriceDetailsContext
  );
  const { triggerFetchVdpPricing } = useContext(UserVehicleContext);
  const { financeInfo: { coApplicantToggleOn = false, hasCoApplicant } = {} } =
    useVdpPricing();
  const userId = useUserId();

  const shouldToggle = isCoApplicantApplied !== coApplicantToggleOn;

  useSubsequentEffect(
    () => {
      if (!shouldToggle) return;

      toggleCoApplicant(userId)
        .then(({ data }) => {
          setCoApplicantApplied(data.coApplicantToggleOn);
          triggerFetchVdpPricing();
        })
        .catch(
          generateErrorLogger(
            'Toggle CoApplicant',
            {},
            {
              callback: () => {
                setCoApplicantApplied(coApplicantToggleOn);
              }
            }
          )
        );
    },
    [
      coApplicantToggleOn,
      setCoApplicantApplied,
      shouldToggle,
      triggerFetchVdpPricing,
      userId
    ],
    Boolean(hasCoApplicant)
  );
}
